module.exports = __webpack_public_path__ + "static/img/2-01.6287b93.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/2-01.png
// module id = z3KH
// module chunks = 1